import request from '@/utils/request'

// 首页获取公告列表
export const getNoticeList = (data) => {
    return request.post('/api/agent/tenderNotice/noticeList',data)
}
//获取公告详情(综合)
export const getNoticeDetail = (data) => {
    return request.get('/api/agent/tenderNotice/getNoticeDetail',data)
}
